import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TenantService } from 'src/app/tenant/tenant.service';
import { member } from '../models/member.model';
import { GlobalService } from '../services/global.service';
import { MemberService } from '../services/member.service';

@Component({
    selector: 'app-member-header',
    templateUrl: './member-header.component.html',
    styleUrls: ['./member-header.component.scss'],
    standalone: false
})
export class MemberHeaderComponent implements OnInit {
  @Input() MemberId: string;
  @Input() hidePicture: boolean = true;
  @Output() completedDisplay = new EventEmitter();
  public member: member;
  public subdomain: string = '';
  public isLoading: boolean = true;
  public isNumeric: boolean = false;

  constructor(
    private _memberService: MemberService,
    private tenantService: TenantService,
    public globalService: GlobalService
  ) { }

  async ngOnInit() {
    this._memberService.isLoading = true;
    this.isLoading = true;
    this.subdomain = this.tenantService.getTenant();
    this.isNumeric = isNaN(Number(this.MemberId)) == false;
    this.hidePicture = this.isNumeric == false? false: this.hidePicture;
    if (this.isNumeric)
      this.member = await this._memberService.getMember(parseInt(this.MemberId));
    else
      this.member = await this._memberService.getMemberFromAccount(this.MemberId);
    this.member.lastName = this.maskdata(this.member.lastName);
    if (this.isNumeric != false) {
      this.member.dateOfBirth = this.maskdate(this.member.dateOfBirth);
      if (this.member.pictureUrl == '')
        this.member.pictureUrl = 'assets/images/avatar.png';
    }
    this._memberService.isLoading = false;
    this.isLoading = false;
    this.completedDisplay.emit(this.member.dateOfBirth);
  }

  maskdata(val: string): string {
    if (this.subdomain == 'demo') return val[0].toUpperCase() + 'XXXXXXXXX';
    return val;
  }

  maskdate(val: Date): Date {
    if (this.subdomain == 'demo') return new Date('01/01/1000');
    return val;
  }
}